import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LegEventFailedAction, LegEventLoadingAction, LegEventPendingAction, LegEventSuccessAction } from './actions';
import { initialLegEventState, LegEventState } from './state';

const legEventSlice = createSlice({
  name: 'leg-event',
  initialState: initialLegEventState,
  reducers: {
    reset: () => initialLegEventState,
    loading: (state: LegEventState, action: PayloadAction<LegEventLoadingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: action.payload.loading,
        loaded: !action.payload.loading,
        pending: false,
        legEvents: state[action.payload.strategyId]?.legEvents ?? []
      };
    },
    pending: (state: LegEventState, action: PayloadAction<LegEventPendingAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: false,
        pending: action.payload.pending,
        legEvents: state[action.payload.strategyId]?.legEvents ?? []
      };
    },
    success: (state: LegEventState, action: PayloadAction<LegEventSuccessAction>) => {
      state[action.payload.strategyId] = {
        error: undefined,
        loading: false,
        loaded: true,
        pending: false,
        legEvents: action.payload.legEvents
      };
    },
    fail: (state: LegEventState, action: PayloadAction<LegEventFailedAction>) => {
      state[action.payload.strategyId] = {
        error: action.payload.error,
        loading: false,
        loaded: true,
        pending: false,
        legEvents: state[action.payload.strategyId]?.legEvents ?? []
      };
    }
  }
});

const { actions, reducer } = legEventSlice;
export const { reset, loading, success, fail, pending } = actions;
export default reducer;
